import React, { useEffect, useState } from 'react';
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css"
import FeatureItem from './FeatureItem';
import FeatureSelectAll from './FeatureSelectAll';
import FeatureSearch from './FeatureSearch';
import FeatureStatus from './FeatureStatus';
import FeatureSelectedItem from './FeatureSelectedItem';

import { useHistory } from 'react-router-dom';

export default function FeatureSelect({ features, filteredFeatures, selectedFeatures, setFeatures, setFilteredFeatures }) {
    const history = useHistory();

    const [dataFilter, setDataFilter] = useState(false);
    const [SQLFilter, setSQLFilter] = useState(false)        

    useEffect(() => {
        if (dataFilter && SQLFilter) {
            setFilteredFeatures(features.filter(item => item.hasData && item.hasSQL))
        } else if (dataFilter) {
            setFilteredFeatures(features.filter(item => item.hasData))
        } else if (SQLFilter) {
            setFilteredFeatures(features.filter(item => item.hasSQL))
        } else {
            setFilteredFeatures(features)
        }
    }, [dataFilter, SQLFilter])

    if (filteredFeatures) {
        const handleSelect = (selectedItems) => {
            setFeatures(selectedItems)
        }

        const handleGroupSelect = (group) => {
            setFeatures([...selectedFeatures, ...filteredFeatures.filter(feature => feature.Category + " Features" === group)])
        }

        const handleInspectFeature = (queryId) => {
            history.push(`/queryBuilder?featureId=${queryId}`);
        }

        const items = filteredFeatures.filter(feature => feature.QueryId).map((feature, i) => ({
            id: i,
            label: feature.Feature,
            group: feature.Category + " Features",
            disabled: false,
            queryId: feature.QueryId,
            onInspect: (queryId) => handleInspectFeature(queryId),
            hasData: feature.hasData || false,
            hasSQL: feature.hasSQL || false,
        }))

        return (
            <div className="ml-5 p-5 mb-3 bg-white shadow">
                <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md mb-5">Select Features</h2>
                <div className="mb-3">
                    <label className="mr-4 block tracking-wide text-gray-600 text-xs font-bold">
                        <input
                            type="checkbox"
                            className="mr-2"
                            checked={dataFilter}
                            onChange={(e) => {
                                setDataFilter(!dataFilter)
                            }}
                        />
                        Show only features with data
                    </label>
                    <label className="block tracking-wide text-gray-600 text-xs font-bold">
                        <input
                            type="checkbox"
                            className="mr-2"
                            checked={SQLFilter}
                            onChange={(e) => {
                                setSQLFilter(!SQLFilter)
                            }}
                        />
                        Show only features with SQL
                    </label>
                </div>
                <MultiSelect
                    items={items}
                    selectedItems={selectedFeatures}
                    onChange={handleSelect}
                    withGrouping
                    wrapperClassName="rounded"
                    itemRenderer={(props) => <FeatureItem {...props} handleGroupSelect={handleGroupSelect} />}
                    selectAllRenderer={(props) => <FeatureSelectAll {...props} />}
                    searchRenderer={(props) => <FeatureSearch {...props} />}
                    selectionStatusRenderer={(props) => <FeatureStatus {...props} />}
                    selectedItemRenderer={(props) => <FeatureSelectedItem {...props} />}
                />
            </div>
        )
    }
}
